var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.800018 2.39985C0.800018 1.92246 0.989661 1.46463 1.32723 1.12706C1.66479 0.789496 2.12263 0.599854 2.60002 0.599854H8.00002C8.47741 0.599854 8.93524 0.789496 9.27281 1.12706C9.61037 1.46463 9.80002 1.92246 9.80002 2.39985V9.59985C9.80002 10.0772 9.61037 10.5351 9.27281 10.8726C8.93524 11.2102 8.47741 11.3999 8.00002 11.3999H2.60002C2.12263 11.3999 1.66479 11.2102 1.32723 10.8726C0.989661 10.5351 0.800018 10.0772 0.800018 9.59985V2.39985ZM12.0977 3.39525C11.9482 3.46994 11.8225 3.58477 11.7346 3.72688C11.6467 3.86899 11.6001 4.03276 11.6 4.19985V7.79985C11.6001 7.96695 11.6467 8.13072 11.7346 8.27283C11.8225 8.41493 11.9482 8.52976 12.0977 8.60445L13.8977 9.50445C14.0349 9.573 14.1873 9.60536 14.3405 9.59846C14.4937 9.59156 14.6426 9.54563 14.7731 9.46503C14.9035 9.38443 15.0112 9.27182 15.0859 9.13791C15.1607 9.00399 15.1999 8.8532 15.2 8.69985V3.29985C15.1999 3.1465 15.1607 2.99571 15.0859 2.8618C15.0112 2.72788 14.9035 2.61528 14.7731 2.53468C14.6426 2.45408 14.4937 2.40814 14.3405 2.40125C14.1873 2.39435 14.0349 2.4267 13.8977 2.49525L12.0977 3.39525Z",
    fill: "#1FC7A5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.28b0b8cffe5fad971441234043fdd9c4.svg";
export { ForwardRef as ReactComponent };